import { render, staticRenderFns } from "./opening-deposit.vue?vue&type=template&id=3c31478c&scoped=true&"
import script from "./opening-deposit.vue?vue&type=script&lang=js&"
export * from "./opening-deposit.vue?vue&type=script&lang=js&"
import style0 from "./opening-deposit.vue?vue&type=style&index=0&id=3c31478c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31478c",
  null
  
)

export default component.exports